var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"form__field--checkbox"},[_c('li',[_c('label',{attrs:{"for":_vm.inputId}},[_c('input',{attrs:{"id":_vm.inputId,"name":_vm.inputName,"true-value":"yes","false-value":"no","type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"input":_vm.change}}),_c('span',[_vm._v(_vm._s(_vm.label))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }